var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-home"},[_c('div',{staticClass:"warp"},[_c('div',{staticClass:"content"},[_c('router-view')],1)]),_vm._v(" "),_c('div',{staticClass:"nav-bar"},[_c('LeftMenu')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78e25492","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/userCenter/UserHome.vue
// module id = null
// module chunks = 